import {Fragment, useState} from 'react';

export function Nodes(props) {
  return props.nodes.map(
      (n,i) => {
        var activeState = null;
        if (props.activeNode && props.activeNodeId === n.id){
          activeState = true;
        }
        else{
          activeState = false;
        }
        return (<Node coord={n.coord} fix={n.fix} key={n.id} nodeid={n.id} selectNode={props.selectNode} active={activeState} mode={props.mode} />)
      }
  );

}

function Node(props) {
  const [hovered, setHover] = useState(false);
  
  const pointerOver = (e) => {
    if(props.mode === 'nodes' || props.mode === 'elements'){
      e.stopPropagation();
      setHover(true);
    }
  }
  const pointerOut = (e) => {
    setHover(false)
  }
  const click = (e) => {
    e.stopPropagation();
    props.selectNode(props.nodeid);
  }
  
  // const positions = new Float32Array(props.coord)
  
  //mesh for showing actual node
  //bigger mesh just for initiating the hover effect (because raycaster precision >1 doesn't work with mesh, it seems)
  return (
    <Fragment>
    <mesh 
      position={props.coord}
    >
        <sphereGeometry args={[6]} />
        <meshBasicMaterial color={hovered ? 'red' : (props.active ? 'red' : (props.fix ? 'coral' : 'blue'))} />
    </mesh>  
    <mesh 
      position={props.coord}
      onPointerOver={pointerOver} 
      onPointerOut={pointerOut}
      onClick={click}
      visible={false}
    >
        <sphereGeometry args={[20,5,4]} />
        <meshBasicMaterial />
    </mesh>    
{/*    <points 
      onPointerOver={hoveron} 
      onPointerOut={hoverout}
      onClick={click} 
      visible={false}>
      <bufferGeometry>
        <bufferAttribute attachObject={["attributes", "position"]} count={positions.length / 3} array={positions} itemSize={3} />
      </bufferGeometry>
      <meshBasicMaterial />
    </points>*/}
    </Fragment>
    );
}